import React from "react";
import { motion } from "framer-motion";

export default function About() {
  return (
    <section className="max-w-4xl mx-auto px-6 pb-20">
      <motion.h2
        initial={{ opacity: 0, y: 8 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
        className="text-xl font-bold text-black dark:text-white mb-5"
      >
        About
      </motion.h2>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.05 }}
        viewport={{ once: true }}
        className="text-[15px] md:text-[17px] leading-7 md:leading-8 text-black/60 dark:text-white/70 max-w-3xl"
      >
        <p>
          Hello! I’m a{" "}
          <b className="text-black dark:text-white font-semibold">
            Computer Science Engineering student
          </b>{" "}
          with a genuine interest in learning technology and improving my skills
          step by step. I enjoy understanding concepts clearly, explaining them
          in a simple way, and I truly like speaking and sharing ideas with
          others.
        </p>

        <p className="mt-5">
          I believe consistent learning, patience, and good communication help
          in growing both personally and professionally. I am currently focusing
          on strengthening my programming, problem-solving, and practical
          development skills while moving steadily toward becoming a responsible
          software professional.
        </p>
      </motion.div>
    </section>
  );
}
